// Ticket detail modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openTicketDetailModal', ticket)
//   el.call('closeTicketDetailModal')
//
// Seeds `root.selectedTicket` ONLY. `TicketsDetailModal` extends Modal with
// stateKey 'selectedTicket'; the SINGLE shell-root instance (workspace/app.js,
// 2026-08-06 consolidation of the former 14 page mounts) shows reactively the
// moment the carrier is set — an instant display flip on EVERY route,
// calendar/documents/files/studio/admin included.
//
// The @symbo.ls/windows custom-template push this helper used to ALSO do is
// deliberately GONE: windows' Slot.set(content) re-prepares the ~4,000-line
// TicketsDetailModal definition synchronously on EVERY open — a measured
// 15-40s main-thread freeze (see the perf note above the shell-root mount in
// app.js; the framework fix for the super-linear prepare is ticketed in
// tickets/smbls.md). First surfaced live when notification clicks started
// opening tickets from arbitrary routes: `/w/<org>?ticket=<id>` hard-froze
// the tab. Pages must NOT re-mount the modal — Modal stateKey semantics
// make any second mounted instance a double-open.

const _rootState = (el) =>
  el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null

// WS-ROOT-DEFAULTS-NO-WRITER-1: root.recentTickets had a reader (chat's
// ##number ref lookup, TicketDetailModal's own urlId scan) but no writer,
// ever — every open funnels through this single choke point, so it is the
// one place a recently-viewed cache can be built without a second writer
// to keep in sync.
const RECENT_TICKETS_CAP = 20

const _ticketKey = (t) => String(t?.id ?? t?._id ?? t?.number ?? '')

export function openTicketDetailModal(ticket) {
  if (!ticket) return
  const root = _rootState(this)
  if (!root) return
  const key = _ticketKey(ticket)
  const prevRecent = Array.isArray(root.recentTickets) ? root.recentTickets : []
  const recentTickets = key
    ? [ticket, ...prevRecent.filter((t) => _ticketKey(t) !== key)].slice(0, RECENT_TICKETS_CAP)
    : prevRecent
  root.update({ selectedTicket: ticket, recentTickets })
}

export function closeTicketDetailModal() {
  const root = _rootState(this)
  root?.update({ selectedTicket: null })
}
